import { render } from "./PagesSearchCard.vue?vue&type=template&id=f956cfe2&ts=true"
import script from "./PagesSearchCard.vue?vue&type=script&lang=ts"
export * from "./PagesSearchCard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__